import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getAccountGeofence } from '@gpx-spa/queries';

/**
 * Composable for managing geofence data on the geofence details page
 * Uses vue-query for data fetching and provides reactive geofence data
 */
export function useGeofence() {
  const store = useStore();
  const route = useRoute();
  
  const accountId = computed(() => store.getters['auth/accountId']);
  const geofenceId = computed(() => +route.params.id);
  
  // Fetch geofence using vue-query
  const { data: geofenceData, isLoading: isGeofenceLoading } = getAccountGeofence(
    accountId,
    geofenceId
  );
  
  // Computed geofence - uses vue-query data when available
  const geofence = computed(() => {
    if (geofenceData.value) {
      return geofenceData.value;
    }
    
    // Fallback to Vuex store for backward compatibility during migration
    return store.getters['geofence/byId'](geofenceId.value);
  });
  
  return {
    geofence,
    isLoading: isGeofenceLoading,
    geofenceId,
    accountId,
  };
}

